import React from 'react';

import {doubleCheckForHttpsUri} from '../lib/utils/uriUtils';

export default function FullWidthVideo({ poster, video, lazy = true}) {

  const {url: videoUrl} = video;
  // const {url: posterUrl} = poster;

  return (
      <video playsInline autoPlay muted loop id="video" preload={'none'}
             poster={!!poster && !!poster.url ? poster.url : ''}
             className={'w-full  relative h-64 md:h-96 lg:h-128 object-cover object-center'}>
        <source
            src={doubleCheckForHttpsUri(videoUrl)}
            type="video/mp4"/>
      </video>
  );
}
